
import { mapGetters, mapActions, mapState } from 'vuex';
import Message from './Message.vue';

export default {
  components: {
    Message,
  },
  props: {
    submitText: {
      type: String,
      default: 'Submit',
    },
    placeholderText: {
      type: String,
      default: '',
    },
    stackIndex: {
      type: Number,
      default: null,
    },
    isUser: {
      type: Boolean,
      default: false,
    },
    highlighed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: '',
    };
  },
  computed: {
    ...mapState('inputFieldStore', ['submittedValue']),
    ...mapGetters('chatbotStore', ['ampConfig']),
  },
  methods: {
    ...mapActions('inputFieldStore', ['setValue']),
    handleSubmit() {
      this.setValue({ value: this.value, stackIndex: this.stackIndex });
    }
  }
};
